export const showOrderItemAddressSelectionDisplay = (display) => {
    var $multiShipElements = $('.displayMultiShip'),
        $displayAddress = $('.displayAddress'),
        $diffAddr = $('.different-address'),
        displayElements = function(currentElement) {
            display ? currentElement.hide() : currentElement.show();
        };
    $.each($multiShipElements, function(index, val) {
        display ? $(this).show() : $(this).hide();
    });
    $.each($displayAddress, function(index, val) {
        displayElements($(this));
    });
    $.each($diffAddr, function(index, val) {
        displayElements($(this));
    });
    if (display) {
        $('#addAddressButton').hide();
        $('#displayMultiShipRadio').prop('checked', 'checked');
    } else {
        $('#addAddressButton').show();
        $('#displayMultiShipRadio').prop('checked', '');
    }
};
